<template>
  <div class="loginView">
    <div class="login_box">
      <div class="title font_size_15 font_weight_600 flex_between">
        <div class="left_title">
          <el-image
            class="image_title"
            :src="showImg(hos_msg.sys_picture)"
            v-if="hos_msg.sys_picture"
            fit="contain"
          >
            <div
              slot="placeholder"
              class="image-slot"
            >
              暂无图片
            </div>
          </el-image>
          <span>{{hos_msg.hos_name}}</span>
        </div>
        <div
          class="qrlogin"
          v-if="login_by_qrcode"
          @click="changeLoginType"
        >
          <span class="iconfont qrfont">&#xe642;</span>
          <div class="qrdiv"></div>
        </div>
        <div
          v-else
          class="change_btn font_weight_500 font_size_1"
          @click="changeLoginType"
        >
          <!-- <span v-if="login_by_password">验证码登录</span> -->
          <!-- <span >二维码登录</span> -->
          <span>使用账号登录</span>
        </div>
      </div>

      <div class="input_box">
        <template v-if="!login_by_qrcode">
          <div class="img">
            <img
              :src="imageUrl"
              alt=""
            >
            <p
              v-if="imageUrl"
              class="tips"
            >微信扫一扫，使用微信手机号登录</p>
          </div>
          <div
            class="over_time"
            v-if="overtime"
            @click="initQR"
          >
            <p class="iconfont">&#xe6c7;</p>
            <p>二维码已过期,请点击刷新</p>
          </div>
        </template>
        <template v-else>
          <el-input
            v-model="form.name"
            placeholder="请输入用户名"
            size="large"
            class="width_all_90 input_item"
          >
            <template #prefix>
              <span class="iconfont icon-yonghu-tianchong"></span>
            </template>
          </el-input>
          <template v-if="login_by_password">
            <el-input
              v-model="form.password"
              placeholder="请输入密码"
              type="password"
              show-password
              size="large"
              @keyup.enter.native="loginNow"
              class="width_all_90 input_item"
            >
              <template #prefix>
                <span class="iconfont icon-mima"></span>
              </template>
            </el-input>
          </template>
          <div
            v-else
            class="flex_between has_code"
          >
            <el-input
              v-model="form.vcode"
              placeholder="请输入验证码"
              size="large"
              @keyup.enter.native="loginNow"
              class="input_item width_220"
            ></el-input>
            <el-button
              size="large"
              class="btn_code"
              @click="getVCodeByPhone"
              :disabled="code_btn_num > 0"
            >
              <span v-if="code_btn_num > 0">{{ code_btn_num }} S</span>
              <span v-else>获取验证码</span>
            </el-button>
          </div>
          <div class="bottom_btn">
            <el-button
              class="width_all_90"
              size="large"
              @click="loginNow"
              :disabled="!is_login"
              type="primary"
            >
              登 录
            </el-button>
          </div>
        </template>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      :close-on-click-modal="false"
      destroy-on-close
      width="450px"
    >
      <el-form
        :model="edit_form"
        ref="edit_form"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item
          label="旧密码："
          prop="old_password"
        >
          <el-input
            v-model="edit_form.old_password"
            type="password"
            show-password
            class="width_220"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码："
          prop="new_password"
        >
          <el-input
            v-model="edit_form.new_password"
            type="password"
            show-password
            class="width_220"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认新密码："
          prop="is_new_pass"
        >
          <el-input
            v-model="edit_form.is_new_pass"
            type="password"
            show-password
            class="width_220"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="editPassword('edit_form')"
          >确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { lcSet, ssSet, ssRemove } from "../utils/utils";
import { useTransitionFallthroughEmits } from 'element-plus';

export default {
  name: "login",
  data () {
    const checkPassNew = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      }
      let length = value.toString().length;
      if (length < 12) {
        callback(new Error('密码至少为12位'))
      }
      let type = 0;
      if (!(value.match(/\d+/g) == null)) {
        type++
      }
      if (!(value.match(/[a-z]+/g) == null)) {
        type++
      }
      if (!(value.match(/[A-Z]+/g) == null)) {
        type++
      }
      if (!(value.match(/[~!@#$%^&*()_=+]+/g) == null)) {
        type++
      }
      if (type < 3) {
        callback(new Error('密码至少包含大写、小写、数字、特殊字符里面的三种'))
      }

      if (length > 30) {
        callback(new Error('密码最多为30位'))
      }
      callback()
    };
    const checkPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请确认新密码'))
      }
      if (value != this.edit_form.new_password) {
        callback(new Error('新密码两次输入不一致'))
      }
      callback()
    };
    return {
      form: {
        name: '',
        password: '',
        vcode: ''
      },
      loginLoading: false,

      dialogVisible: false,
      dialogTitle: '修改密码',
      edit_form: {},
      rules: {
        old_password: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        new_password: [{ required: true, validator: checkPassNew, trigger: 'blur' }],
        is_new_pass: [{ required: true, validator: checkPass, trigger: 'blur' }]
      },

      code_btn_num: 0,
      vcode_int: null,

      login_by_password: true,
      login_by_qrcode: true,
      checkloginTimer: null,
      refeshImgTimer: null,
      imageUrl: '',
      qrUid: '',
      overtime: false,
    }
  },
  computed: {
    ...mapState('homeData', [
      'hos_msg',
      'sys_version',
    ]),
    is_login () {
      let pass = this.form.name && this.form.password;
      let code = this.form.name && this.form.vcode;
      return pass || code
    }
  },
  watch: {
    login_by_qrcode () {
      if (this.login_by_qrcode) {
        this.removeQR()
      } else {
        this.initQR()
      }
    },
  },
  created () {
  },
  mounted () {
    // if (this.hos_msg.not_get) {
    //     this.getHosData()
    // }
    // this.getComConfig()
  },
  methods: {
    ...mapMutations('homeData', {
      setHosMsg: 'setHosMsg',
      set_login_type: 'set_login_type',
    }),
    ...mapActions('homeData', {
      getComConfig: 'getComConfig',
    }),

    changeLoginType () {
      //   this.login_by_password = !this.login_by_password;
      this.login_by_qrcode = !this.login_by_qrcode
      this.form.password = '';
      this.form.vcode = '';
    },
    getVCodeByPhone () {
      let phone = this.form.name;
      let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(phone)) {
        this.$http.warning('请输入正确的手机号');
        return
      }
      let params = {
        phone: phone,
      };
      this.$http.post('/send_vcode', params).then(res => {
        this.changeVcodeTime();
      })
    },
    changeVcodeTime () {
      this.code_btn_num = 60;
      this.vcode_int = setInterval(() => {
        this.code_btn_num--;
        if (this.code_btn_num < 1) {
          clearInterval(this.vcode_int)
        }
      }, 1000)
    },

    openEdit () {
      this.edit_form = {
        old_password: '',
        new_password: '',
        is_new_pass: '',
      };
      this.dialogVisible = true;

      this.form.password = '';
      this.loginLoading = false;
    },
    editPassword (ref) {
      this.$refs[ref].validate(valid => {
        if (valid) {
          let params = {
            new_password: this.edit_form.new_password,
            old_password: this.edit_form.old_password,
          };
          this.$http.post('/user/password/update', params).then(res => {
            this.$http.successing('修改密码成功，请重新登录');
            this.dialogVisible = false;
            this.form.password = '';
            this.loginOut()
          }).catch(err => {
            this.$http.erroring(err.msg, true, 1000 * 10);
          })
        }
      })
    },
    loginOut () {
      this.$http.get('/logout').then(res => {
        sessionStorage.clear();
        // localStorage.clear();
        lcRemove('token')
      })
    },

    showImg (url) {
      return this.$http.getImageUrl(url)
    },
    loginNow () {
      if (!this.is_login) return;
      if (this.loginLoading) return;
      ssSet('login_type', this.login_by_password ? 'pass' : 'code')

      this.loginLoading = true;
      let params = {
        user_name: this.form.name,
        password: this.form.password
      };
      let url = '/login';

      if (!this.login_by_password) {
        // 验证码登录
        params = {
          phone: this.form.name,
          vcode: this.form.vcode
        };
        url = '/phone_login'
      }

      this.$http.post(url, params).then(res => {
        this.$http.successing('登录成功！');
        lcSet('token', res.data.token);
        ssSet('user', JSON.stringify(res.data.user));
        ssRemove('is_locked');
        ssRemove('not_first');
        let query = this.$route.query;
        this.$router.push({
          path: 'homeView',
          query,
        });
        setTimeout(() => {
          this.loginLoading = false;
        }, 500)
      }).catch(err => {
        // 过期后不允许登录，直接修改代码
        console.log(err, 'err');

        if (err.code === 1004) {
          lcSet('token', err.data.token);
          this.$http.erroring('密码已过期，请修改密码');
          this.openEdit()
        } else {
          this.$http.erroring(err.msg);
        }

        setTimeout(() => {
          this.loginLoading = false;
        }, 500)
      })
    },
    getHosData () {
      this.$http.get('/sysname_and_icon').then(res => {
        let data = {
          hos_name: res.sysconfig.sys_name,
          sys_picture: res.sysconfig.sys_picture,
        };
        this.setHosMsg(data);
      })
    },
    qrlogin () {
      let params = {
        uid: this.qrUid,
      }
      this.$http.get('/login_check', params).then((res) => {
        if (res.data) {
          if (this.refeshImgTimer) clearTimeout(this.refeshImgTimer);
          if (this.checkloginTimer) clearInterval(this.checkloginTimer)
          this.$http.successing('登录成功！');
          lcSet('token', res.data.token);
          ssSet('user', JSON.stringify(res.data.user));
          ssRemove('is_locked');
          ssRemove('not_first');
          let query = this.$route.query;
          this.$router.push({
            path: 'homeView',
            query,
          });
          setTimeout(() => {
            this.loginLoading = false;
          }, 500)
        }
      }).catch(err => {
        console.log(err, 'ss');

      })
    },
    async initQR () {
      this.overtime = false
      const imgSrc = this.$http.getImageUrl('/login_qrcode', true);
      try {
        // 发起请求获取图片资源
        const response = await fetch(imgSrc);
        // 检查请求是否成功
        if (!response.ok) {
          throw new Error(`请求失败: ${response.status}`);
        }

        // 获取所有响应头
        const responseHeaders = {};
        response.headers.forEach((value, key) => {
          responseHeaders[key] = value;
        });
        // 将响应头保存到变量
        // 将图片转为Blob URL用于显示
        const blob = await response.blob();
        this.imageUrl = URL.createObjectURL(blob);
        this.qrUid = responseHeaders['x-uid'];
        if (this.checkloginTimer) clearInterval(this.checkloginTimer)
        this.refeshImgTimer = setTimeout(() => {
          // this.initQR()
          this.overTimeQR()
        }, 60 * 1000);
        this.checkloginTimer = setInterval(() => {
          this.qrlogin()
        }, 1000);
      } catch (error) {
        console.error('获取图片响应头失败:', error);
      }
    },
    overTimeQR () {
      this.overtime = true
      if (this.refeshImgTimer) clearTimeout(this.refeshImgTimer);
      if (this.checkloginTimer) clearInterval(this.checkloginTimer)
    },
    removeQR () {
      this.imageUrl = '';
      this.qrUid = '';
      if (this.refeshImgTimer) clearTimeout(this.refeshImgTimer);
      if (this.checkloginTimer) clearInterval(this.checkloginTimer)
    },
  }
}
</script>

<style scoped lang="scss">
.loginView {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: var(--background-header-color);
  .login_box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background-color: var(--ui-gray-darkest);
    background-color: var(--background-base-color);
    width: 500px;
    min-height: 200px;
    text-align: center;
    border-radius: 10px;
    .title {
      margin: 15px 20px;
      text-align: left;
      display: flex;
      align-items: center;
      .left_title {
        display: flex;
        align-items: center;
      }
      .image_title {
        margin-right: 15px;
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 5px;
      }

      .change_btn {
        color: var(--primary-color-2);
        cursor: pointer;
        padding: 0 15px;
      }
      .qrlogin {
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #eee;
        border-top-right-radius: 10px;
        cursor: pointer;
        .qrdiv {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 40px 0 0 40px;
          border-color: transparent transparent transparent #fff;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .qrfont {
          font-size: 40px;
        }
      }
    }
    .input_box {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .input_item {
        margin: 10px 0;
      }
      .el-input__inner {
        padding: 0 10px;
      }

      .has_code {
        padding: 0 20px;
        .btn_code {
          width: 100px;
        }
      }
      .img {
        width: 300px;
        box-sizing: border-box;
        padding: 20px;
        position: relative;
        img {
          width: 100%;
        }
        .tips {
          color: #888;
          position: absolute;
          bottom: 5px;
          left: 50%;
          transform: translateX(-50%);
          white-space: nowrap;
        }
      }
      .over_time {
        position: absolute;
        width: 300px;
        height: 300px;
        background-color: rgba(244, 244, 244, 0.8);
        top: 65px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .iconfont {
          margin-bottom: 10px;
        }
      }
    }
    .bottom_btn {
      width: 100%;
      margin: 15px 0;
    }

    .version {
      padding-right: 30px;
      text-align: right;
      /*margin: 15px 0;*/
      color: var(--el-color-warning-light-3);
      font-size: 0.85rem;
    }
  }
}
</style>